import { Section } from '../types';
import {
  DropdownMenuSectionSplit,
  DropdownMenuSectionTitle,
  OptionDescription,
} from '../atoms';
import { DropdownMenuOption } from './DropdownMenuOption';

export const DropdownMenuSection = ({
  title,
  description,
  options = [],
  truncateDescription,
  truncateTitle,
}: Section) => (
  <>
    {title && (
      <DropdownMenuSectionTitle $shouldTruncate={truncateTitle}>
        {title}
      </DropdownMenuSectionTitle>
    )}
    {description && (
      <OptionDescription $shouldTruncate={truncateDescription}>
        {description}
      </OptionDescription>
    )}
    {options.map((optionProps, index) => (
      <DropdownMenuOption key={index} {...optionProps} />
    ))}
    {(title || description || Boolean(options.length)) && (
      <DropdownMenuSectionSplit />
    )}
  </>
);
